import { render, staticRenderFns } from "./Klondike.vue?vue&type=template&id=243168df&"
import script from "./Klondike.vue?vue&type=script&lang=js&"
export * from "./Klondike.vue?vue&type=script&lang=js&"
import style0 from "./Klondike.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports